export const DEFAULT_COLUMN_WIDTH = 150;
export const DEFAULT_PAGE_SIZE = 200;

export enum RowHeights {
  dense = 24,
  normal = 36,
  sparse = 52,
}
